var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.$route.params.formName === 'newPressNewForm')?_c('NewPressNewForm'):_vm._e(),(_vm.$route.params.formName === 'modifyPressNewForm')?_c('ModifyPressNewForm'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }